var checkoutInputsSelector = '#message, #remark, input[type="text"]:not(#vatId), input[type="email"], input[type="password"], input[type="tel"]';

function syncFocused() {
    $(checkoutInputsSelector).each(function () {
        $(this).closest('.form-group').toggleClass('focused', !!$(this).val() || $(this).is(':focus'));
    });
}

syncFocused();
$(window).on('pageshow', syncFocused);

$(document).on('click focus', checkoutInputsSelector, function () {
    $(this).closest('.form-group').addClass('focused');
});

$(document).on('blur change input', checkoutInputsSelector, function () {
    $(this).closest('.form-group').toggleClass('focused', !!$(this).val() || $(this).is(':focus'));
});

$(document).on('click', '.top-nav-button-login, [data-testid="signin"]', function () {
    requestAnimationFrame(function () {
        requestAnimationFrame(syncFocused);
    });
});
